import { client } from "@scayla/api-client-fetch/client";
import { baseConfig, useLogger, useOidcStore } from "@scayla/core";

const logger = useLogger("api");

client.setConfig({
  baseUrl: baseConfig.scaylaApiUrl,
  auth: (auth) => {
    logger.debug(`Getting auth token for auth:`, auth);
    const token = useOidcStore().state.value.token;
    if (auth.type === "http" && auth.scheme === "bearer" && token) {
      return token;
    }
  },
});

client.interceptors.request.use(async (request) => {
  const oidcStore = useOidcStore();
  const token = oidcStore.state.value.token;
  const user = oidcStore.state.value.user;

  if (!token) {
    throw new Error("No auth token available");
  }

  if (user?.expired) {
    await oidcStore.state.value.userManager?.signinRedirect();
    throw new Error("Auth token has expired");
  }

  request.headers.set("Authorization", `Bearer ${token}`);
  return request;
});
